import { useTranslation } from 'react-i18next';

import { ChatsRoute } from '@/features/chats/navigation/chatsRoute';
import { ChatArchiveScreen } from '@/features/chats/screens/ChatArchiveScreen';
import { ChatOnCommentScreen } from '@/features/chats/screens/ChatOnCommentScreen';
import { ChatOnGroupScreen } from '@/features/chats/screens/ChatOnGroupScreen';
import { ChatOnPostScreen } from '@/features/chats/screens/ChatOnPostScreen';
import { ChatScreen } from '@/features/chats/screens/ChatScreen';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { AppStack } from '@/navigation/stacks/appStack';

export const useChatsRouting = () => {
  const { t } = useTranslation(LocalizationNameSpace.CHATS);
  return {
    chatsScreens: [
      <AppStack.Screen
        key={ChatsRoute.Chat}
        name={ChatsRoute.Chat}
        component={ChatScreen}
        getId={({ params }) => params.id}
      />,
      <AppStack.Screen
        key={ChatsRoute.ChatArchive}
        name={ChatsRoute.ChatArchive}
        component={ChatArchiveScreen}
        options={() => ({
          title: t(ChatsRoute.ChatArchive)
        })}
      />,
      <AppStack.Screen
        key={ChatsRoute.NewChatOnPost}
        name={ChatsRoute.NewChatOnPost}
        component={ChatOnPostScreen}
        getId={({ params }) => params.postId}
      />,
      <AppStack.Screen
        key={ChatsRoute.NewChatOnComment}
        name={ChatsRoute.NewChatOnComment}
        component={ChatOnCommentScreen}
        getId={({ params }) => params.commentId}
      />,
      <AppStack.Screen
        key={ChatsRoute.NewChatOnGroup}
        name={ChatsRoute.NewChatOnGroup}
        component={ChatOnGroupScreen}
        getId={({ params }) => params.groupId + '_' + params.memberId}
      />
    ]
  };
};
